module.exports = __webpack_public_path__ + "static/images/components/BuildingCardImage/images/arrow/arrow-0-100.a65db5ab.png";


//////////////////
// WEBPACK FOOTER
// ./components/BuildingCardImage/images/arrow/arrow-0-100.png
// module id = 2547
// module chunks = 11